import { render, staticRenderFns } from "./SentryBindings.vue?vue&type=template&id=23fa946b&"
import script from "./SentryBindings.vue?vue&type=script&lang=ts&"
export * from "./SentryBindings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports